import AttachmentsViewerMediaBase from "components/attachments/viewer/media/media.client.base"
import { Component } from "vue-property-decorator"

@Component
export default class AttachmentsViewerMediaWeb extends AttachmentsViewerMediaBase {}
